import { useRestQuery } from 'utils/hooks/api';
import { MOVABLE_INK_GET_CHILD_INTEGRATIONS } from 'api/MovableInkIntegrationsAPI';
import { MovableInkChildIntegration } from '../types';

type MovableInkChildIntegrationResponse = {
  accounts: MovableInkChildIntegration[];
};

type MovableInkChildIntegrationRequest = {
  tokenId?: number;
};

export const useGetChildIntegrations = (tokenId?: number) => {
  const {
    data: { accounts = [] } = {},
    isLoading,
    isError,
    isSuccess,
    refetch,
  } = useRestQuery<MovableInkChildIntegrationResponse, MovableInkChildIntegrationRequest>(
    MOVABLE_INK_GET_CHILD_INTEGRATIONS,
    { tokenId },
    {
      refetchOnMount: false,
      staleTime: Infinity,
      enabled: !!tokenId,
      retry: false,
      refetchOnWindowFocus: false,
    },
  );

  return {
    data: accounts,
    isLoading,
    isError,
    isSuccess,
    refetch,
  };
};
